import { logButtonClick } from 'features/navigation/utils/analytics';

import { ClickEventComponentNames } from 'state/amplitude';

export const sendHeroClickEvent = ({
  imageLink,
  daypart,
}: {
  imageLink: string;
  daypart?: string | null;
}) => {
  logButtonClick({
    attributes: {
      component: ClickEventComponentNames.BUTTON,
      name: 'Homepage Hero image',
      url: imageLink ?? '',
      daypart: daypart ?? '',
    },
  });
};
